import React, { useEffect, useRef, useState } from "react";
import SpinAlert from "./SpinAlert";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { useNavigate } from "react-router-dom";
import SpinAudio from "../../assets/spin/audio.wav";
import SpinAudioWin from "../../assets/spin/win.wav";
// Moved up so JSX can reference it without ReferenceError
const awards = [
  { id: 1, image: "1 Award.webp", amount: "100 USDT" },
  { id: 2, image: "2 Award.webp", amount: "200 USDT" },
  { id: 3, image: "3 Award.webp", amount: "300 USDT" },
  { id: 4, image: "4 Award.webp", amount: "400 USDT" },
  { id: 5, image: "5 Award.webp", amount: "500 USDT" },
  { id: 6, image: "6 Award.webp", amount: "600 USDT" },
  { id: 7, image: "7 Award.webp", amount: "700 USDT" },
  { id: 8, image: "8 Award.webp", amount: "800 USDT" },
  { id: 9, image: "9 Award.webp", amount: "900 USDT" },
  { id: 10, image: "10 Award.webp", amount: "1,000 USDT" },
  { id: 11, image: "11 Award.webp", amount: "1,100 USDT" },
  { id: 12, image: "12 Award.webp", amount: "1,200 USDT" },
  { id: 13, image: "13 Award.webp", amount: "1,300 USDT" },
  { id: 14, image: "14 Award.webp", amount: "1,400 USDT" },
  { id: 15, image: "15 Award.webp", amount: "1,500 USDT" },
  { id: 16, image: "16 Award.webp", amount: "5,000 USDT" },
  { id: 17, image: "17 Award.webp", amount: "10,000 USDT" },
  { id: 18, image: "18 Award.webp", amount: "20,000 USDT" },
];

const sectors = [
  { label: "1", number: 1 },
  { label: "2", number: 2 },
  { label: "3", number: 3 },
  { label: "4", number: 4 },
  { label: "5", number: 5 },
  { label: "6", number: 6 },
  { label: "7", number: 7 },
  { label: "8", number: 8 },
  { label: "9", number: 9 },
  { label: "10", number: 10 },
  { label: "11", number: 11 },
  { label: "12", number: 12 },
  { label: "13", number: 13 },
  { label: "14", number: 14 },
  { label: "15", number: 15 },
  { label: "50", number: 16 },
  { label: "100", number: 17 },
  { label: "150", number: 18 },
];

const Spin = () => {
  const navigate = useNavigate();

  // Ref to the rotating wheel div (replaces canvas — your CSS wheel is the real wheel)
  const wheelRef = useRef(null);
  const winSound = useRef(null);
  const [predefinedWinner, setPredefinedWinner] = useState(0);
  const [ang, setAng] = useState(0);
  const [spinning, setSpinning] = useState(false);
  const [soundEnabled, setSoundEnabled] = useState(false);
  const [winner, setWinner] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [winnerList, setWinnerList] = useState([]);
  const spinSound = useRef(null);

  // Rotate the CSS wheel div directly
  const rotateWheel = (angle) => {
    if (wheelRef.current) {
      wheelRef.current.style.transform = `rotate(${angle}rad)`;
    }
  };

  const spinWheel = async () => {
    if (spinning) return;

    if (!spinSound.current) {
      spinSound.current = new Audio(SpinAudio);
      spinSound.current.loop = true; // loop while spinning
    }

    let status, data;
    try {
      ({ status, data } = await apiGet(apiPath.checkSpin));
    } catch (err) {
      return showModal_(
        "WARNING ALERT",
        err?.response?.data?.message || "Unable to spin.",
      );
    }
    if (status !== 200 || !data?.success) {
      return showModal_("WARNING ALERT", data?.message || "Unable to spin.");
    }

    const winningSector = sectors.find(
      (s) => s.label == String(data.results.winAmount),
    );
    if (!winningSector) {
      console.error("No sector found for winAmount:", data.results.winAmount);
      return showModal_("ERROR", "Invalid win amount from server.");
    }
    // let winningSector = { number: 6 };
    // console.log(winningSector, "winningSector");
    const index = winningSector.number - 1; // 0-based index  ✅ back
    setPredefinedWinner(winningSector.number);
    setWinner(null);
    setSpinning(true);
    // console.log(index,'index')
    const TAU = 2 * Math.PI;
    const anglePerSector = TAU / sectors.length;

    // Calculate the target stop angle so the winning sector lands under the pointer
    // Pointer is at top (12 o'clock). Sectors are laid out clockwise.
    // To center sector `index` under the pointer:
    //   targetAngle = TAU - (index * anglePerSector) - (anglePerSector / 2)

    // const targetAngle = TAU - index * anglePerSector - anglePerSector / 2;
    const targetAngle = (TAU - index * anglePerSector) % TAU;
    const currentAng = ang % TAU;
    // Add full spins so it looks like it's actually spinning, then snap to target
    const fullSpins = 6;
    const delta = (targetAngle - currentAng + TAU) % TAU;
    const finalAngle = currentAng + TAU * fullSpins + delta;

    const duration = 6000; // ms
    const startTime = performance.now();

    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
    const animate = (now) => {
      const elapsed = now - startTime;
      const t = Math.min(elapsed / duration, 1);
      const eased = easeOutCubic(t);
      const current = currentAng + (finalAngle - currentAng) * eased;

      rotateWheel(current);
      if (t < 1) {
        requestAnimationFrame(animate);
      } else {
        const settled = finalAngle % TAU;

        setAng(settled);
        rotateWheel(settled);
        setSpinning(false);
        onSpinEnd(index);
      }
    };

    requestAnimationFrame(animate);

    try {
      spinSound.current.currentTime = 0;
      await spinSound.current.play();
    } catch (err) {
      console.error("Audio play error:", err);
    }
  };

  const onSpinEnd = async (index) => {
    const finalSector = sectors[index];
    if (!finalSector) {
      console.error("Sector not found at index:", index);
      return;
    }

    // ✅ Stop spin audio
    if (spinSound.current) {
      spinSound.current.pause();
      spinSound.current.currentTime = 0;
    }

    try {
      const { status, data } = await apiPost(apiPath.updateSpin);

      if (status === 200 && data?.success) {
        setWinner(finalSector.label);

        setWinnerList((prev) => {
          const updated = [...prev, { result: finalSector.label }];
          return updated;
        });

        // ✅ Play win audio on success
        if (!winSound.current) {
          winSound.current = new Audio(SpinAudioWin);
        }
        try {
          winSound.current.currentTime = 0;
          await winSound.current.play();
        } catch (err) {
          console.error("Win audio error:", err);
        }

        showModal_("Congratulations!", `Woop! You won ${finalSector.label}`);
      } else {
        showModal_("ERROR", data?.message || "Something went wrong.");
      }
    } catch (err) {
      console.error("Error in onSpinEnd:", err);
      showModal_(
        "ERROR",
        err?.response?.data?.message || "Network error. Please try again.",
      );
    }
  };

  // Helper to open the modal
  const showModal_ = (title, message) => {
    setModalTitle(title);
    setModalMessage(message);
    // if (title === "ALL RESULTS") {
    //   const saved = JSON.parse(localStorage.getItem("winner")) || [];
    //   setWinnerList(saved);
    // }
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const openPopUp = () => {
    showModal_(
      "ALL RESULTS",
      "This section shows all the results selected during the current visit.",
    );
  };

  const getWinningList = async () => {
    try {
      const { status, data } = await apiGet(apiPath.getwiningRecord);

      if (status === 200) {
        const results = data?.results;

        if (Array.isArray(results)) {
          setWinnerList(results);
        } else {
          setWinnerList([]);
        }
      }
    } catch (error) {
      console.error("Error fetching winning list:", error);
      setWinnerList([]);
    }
  };

  useEffect(() => {
    getWinningList();
  }, []);

  // spin.css is large and global, so load it only while this page is mounted
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/assets/css/spin.css";
    document.head.appendChild(link);
    return () => {
      link.remove();
      spinSound.current?.pause();
    };
  }, []);

  return (
    <div _nghost-serverapp-c93 className="app-spinwinner">
      <div
        _ngcontent-serverapp-c93
        className="roulette confetti-container ng-star-inserted"
      >
        <div _ngcontent-serverapp-c93 className="roulette_wrap">
          <div _ngcontent-serverapp-c93 className="roulette_main">
            <img
              _ngcontent-serverapp-c93
              src="/assets/spin/logo.webp?v=4521457"
              className="mainspinwin"
            />

            {/* ✅ Attach wheelRef here — this is the element that rotates */}
            <div
              _ngcontent-serverapp-c93
              className={`roulette_main_wrap roulette_P8_N8 luckyfortune `}
            >
              <ul
                ref={wheelRef}
                _ngcontent-serverapp-c93
                className={`roulette_main_part roulette_main_part-18 luckyfortune ${spinning ? "roulette_main_wrap-rotate" : ""}`}
              >
                {Array.from({ length: 18 }).map((_, i) => (
                  <li
                    key={i}
                    _ngcontent-serverapp-c93
                    className="roulette_main_part_list ng-star-inserted"
                  >
                    <div
                      _ngcontent-serverapp-c93
                      className="roulette_main_part_color"
                    />
                  </li>
                ))}
              </ul>

              <div
                onClick={spinWheel}
                _ngcontent-serverapp-c93
                className="roulette_main_btn"
              />

              <div
                _ngcontent-serverapp-c93
                onClick={() => navigate("/")}
                className="roulette_main_back"
                style={{ width: "15%" }}
                tabIndex={0}
              >
                <div _ngcontent-serverapp-c93>
                  <img
                    _ngcontent-serverapp-c93
                    src="/assets/spin/back.webp?v=52145"
                    alt="back"
                  />
                </div>
              </div>

              <div
                _ngcontent-serverapp-c93
                className="roulette_main_numberTimes"
              >
                <div _ngcontent-serverapp-c93>
                  <div _ngcontent-serverapp-c93>
                    {/* ✅ Show actual winner count */}
                    <span _ngcontent-serverapp-c93>{winnerList.length}</span>
                    <span _ngcontent-serverapp-c93>coins</span>
                  </div>
                </div>
              </div>
            </div>

            <div _ngcontent-serverapp-c93 className="roulette_main_coin">
              {[1, 3, 2, 4, 5, 6].map((n, i) => (
                <span
                  key={i}
                  _ngcontent-serverapp-c93
                  className="roulette_main_coinWrap"
                >
                  <img
                    _ngcontent-serverapp-c93
                    src={`/assets/spin/${n}.webp`}
                    className={`roulette_main_coin_${i + 1}`}
                    alt=""
                  />
                </span>
              ))}
            </div>
          </div>

          <div _ngcontent-serverapp-c93>
            <ul _ngcontent-serverapp-c93 className="rouletteMain_head">
              <div _ngcontent-serverapp-c93 className="rouletteName">
                Fun Wheel
              </div>
            </ul>
          </div>

          <div _ngcontent-serverapp-c93 className="roulette_minor">
            <ul _ngcontent-serverapp-c93 className="roulette_awards">
              {awards.map((item) => (
                <li
                  key={item.id}
                  _ngcontent-serverapp-c93
                  className="roulette_awards_item ng-star-inserted"
                >
                  <div _ngcontent-serverapp-c93>
                    <div
                      _ngcontent-serverapp-c93
                      className="roulette_awards_medals"
                    />
                    <div
                      _ngcontent-serverapp-c93
                      className="roulette_awards_prize"
                    >
                      <img
                        _ngcontent-serverapp-c93
                        src={`/assets/spin/${item.image}?v=58547`}
                        alt={item.amount}
                      />
                    </div>
                    <div
                      _ngcontent-serverapp-c93
                      className="roulette_awards_text"
                    >
                      {item.amount}
                    </div>
                  </div>
                </li>
              ))}
            </ul>

            {/* ✅ Winner list with real data */}
            <div _ngcontent-serverapp-c93 className="roulette_winner">
              <div _ngcontent-serverapp-c93 className="roulette_winner_wrap">
                <div
                  _ngcontent-serverapp-c93
                  className="roulette_winner_head winnerList"
                >
                  <div
                    _ngcontent-serverapp-c93
                    className="roulette_winner_headItem"
                  >
                    Winning record
                  </div>
                  <div
                    _ngcontent-serverapp-c93
                    id="list-record"
                    className="roulette_winner_headCursor leftMost"
                    onClick={openPopUp}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <div
                  _ngcontent-serverapp-c93
                  className="roulette_winner_slider"
                >
                  <table className="table table-bordered table-striped" style={{ width: `100%` }}>
                    <thead>
                      <tr>
                        <th>Username</th>
                        <th>Result</th>
                      </tr>
                    </thead>
                    <tbody>
                      {winnerList.length === 0 ? (
                        <tr>
                          <td colSpan="2" style={{ textAlign: "center" }}>
                            No data
                          </td>
                        </tr>
                      ) : (
                        winnerList.map((w, i) => (
                          <tr key={w._id || i}>
                            <td>{w?.userName}</td>
                            <td>{w?.result}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div _ngcontent-serverapp-c92 className="roulette_rule">
              <h3
                _ngcontent-serverapp-c92
                className="roulette_rule_title2 roulette_rule_title"
              >
                নিয়ম ও শর্তাবলী প্রযোজ্য:{" "}
              </h3>
              <p _ngcontent-serverapp-c92 className="rouletteRule_text" />
              <p _ngcontent-serverapp-c92>
                <strong _ngcontent-serverapp-c92>
                  <span
                    _ngcontent-serverapp-c92
                    style={{ "font-size": "14px" }}
                  >
                   বাজিফেয়ার লাকি হুইল :

                  </span>
                </strong>
              </p>
              <p _ngcontent-serverapp-c92>
                <strong _ngcontent-serverapp-c92>
                  <span
                    _ngcontent-serverapp-c92
                    style={{ "font-size": "14px" }}
                  >
                    নিয়ম ও শর্তাবলী প্রযোজ্য :{" "}
                  </span>
                </strong>
              </p>
              <p _ngcontent-serverapp-c92>
                <span _ngcontent-serverapp-c92 style={{ "font-size": "14px" }}>

                  আপনি যদি একজন নিয়মিত ব্যবহারকারী হন, তবে প্রতিদিন ন্যূনতম <span _ngcontent-serverapp-c92>৫০ </span> পয়েন্টের ক্ষতি হলে আপনি একটি ফ্রি কুপন পাবেন—যার মাধ্যমে বিশাল অঙ্কের পুরস্কার জেতার সুযোগ রয়েছে। চাকাটি ঘোরানোর (স্পিন করার) পর, আপনার জেতা পুরস্কারের অর্থ আপনার অ্যাকাউন্টে জমা হয়ে যাবে। ধন্যবাদ।

                </span>
              </p>



            </div>

            <div
              _ngcontent-serverapp-c92
              className="roulette_rule"
              style={{ "margin-top": "56px" }}
            >
              <h3 _ngcontent-serverapp-c92 className="roulette_rule_title">
                Terms &amp; Conditions:{" "}
              </h3>
              <p _ngcontent-serverapp-c92 className="rouletteRule_text" />
              <p _ngcontent-serverapp-c92>
                <strong _ngcontent-serverapp-c92>
                  <span
                    _ngcontent-serverapp-c92
                    style={{ "font-size": "14px" }}
                  >
                  Bajifair Lucky Wheel:


                  </span>
                </strong>
              </p>
              <p _ngcontent-serverapp-c92>
                <strong _ngcontent-serverapp-c92>
                  <span
                    _ngcontent-serverapp-c92
                    style={{ "font-size": "14px" }}
                  >
                    Terms &amp; Conditions:{" "}
                  </span>
                </strong>
              </p>
              <p _ngcontent-serverapp-c92>

                <span _ngcontent-serverapp-c92 style={{ "font-size": "14px" }}>
                  If you are a regular user, you will receive one free coupon—offering a potentially massive winning amount—whenever you incur a minimum daily loss of <span _ngcontent-serverapp-c92>50 </span>
                  points. Once you spin, the winnings will be credited to your account. Thank you.
                </span>
              </p>


            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <SpinAlert
          modalTitle={modalTitle}
          modalMessage={modalMessage}
          winnerList={winnerList}
          closeModal={closeModal}
        />
      )}
    </div>
  );
};

export default Spin;
